// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatGetOrCreatePrivateBody = {
  targetUserId: string;
};

export type typeChatGetOrCreatePrivateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { chatId: string; isNewRequest: boolean; isApproved: boolean };
};

export type typeChatGetOrCreatePrivateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatGetOrCreatePrivateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatGetOrCreatePrivateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatGetOrCreatePrivateBody = {
  type: "object",
  properties: {
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatGetOrCreatePrivate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatGetOrCreatePrivateBody);
  }

  return async function postChatGetOrCreatePrivate(
    payload: typeChatGetOrCreatePrivateBody,
  ): Promise<
    typeChatGetOrCreatePrivateOutput200 | typeChatGetOrCreatePrivateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatGetOrCreatePrivate" failed before calling the network. #0e81451ce912`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#0e81451ce912" },
        },
        data: null,
      } as typeChatGetOrCreatePrivateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/get-or-create-private`,
      httpMethod: "POST",
      options,
    })) as
      typeChatGetOrCreatePrivateOutput200 | typeChatGetOrCreatePrivateOutput400;
  };
}
